import React from 'react'
import styled from 'styled-components'
import '../../styles/admin.css'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

const ModalContent = styled.div`
  background-color: white;
  border-top: 4px solid ${(props) => props.borderColor || '#060'};
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 90%;
  max-width: 400px;
  text-align: center;
`

const MessageText = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 24px;
  color: #2d3748;
`

const MessageModal = ({ message, show, onClose, borderColor }) => {
  if (!show) {
    return null
  }

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent borderColor={borderColor} onClick={(e) => e.stopPropagation()}>
        <MessageText>{message}</MessageText>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button type="button" className="btn btn-primary" style={{ minWidth: '120px' }} onClick={onClose}>
            OK
          </button>
        </div>
      </ModalContent>
    </ModalOverlay>
  )
}

export default MessageModal
